import { createApp } from 'vue';
import XlsxToPdfConverter from '../Components/XlsxToPdfConverter.vue';
import '@styles/app.css';

createApp(XlsxToPdfConverter).mount('#xlsx-to-pdf-converter');
